import { Action } from 'redux';

import { ChangeCollectionVisibility } from '../../AppActionTypes';
import { ICollectionInfo } from '../../../spaces/Collections/ICollectionInfo';

export interface ChangeCollectionVisibilityAction extends Action {
  targetItem: ICollectionInfo;
}

export function changeCollectionVisibility(targetItem: ICollectionInfo): ChangeCollectionVisibilityAction {
  return {
    type: ChangeCollectionVisibility,
    targetItem
  };
}
